import Section from "../../components/UI/Section/Section";

import Header from "../../components/UI/Header/Header";
import ArrowBack from "../../components/ArrowBack/ArrowBack";

export default () => {
  return (
    <>
      <ArrowBack />
      <Section>
        <Header>Политика конфиденциальности</Header>
        <p>
          Политика конфиденциальности и использования персональных данных
          находится &nbsp;
          <a
            style={{ color: "inherit" }}
            href="https://mammoth-guardian-dfa.notion.site/38bc32a3a59045569dae0712e93d2c1a"
          >
            по этой ссылке
          </a>
          .
        </p>
      </Section>
    </>
  );
};
